module.exports = __webpack_public_path__ + "static/media/findBanner.223eae14.jpg";